import {LocationTypes} from '@/src/hooks/useCountriesList';
import LocationsSelectFilter from '@/src/Search/containers/LocationsSelectFilter';

const ClinicFilters = () => {
  return (
    <div>
      <LocationsSelectFilter locationType={LocationTypes.WITH_CLINICS} />
    </div>
  );
};

export default ClinicFilters;
